<template>
  <div class="student mb-5">
    <div class="student-details" @click="dialogVisible = true">
      <div class="avatar">
        <img v-if="student.vatar" :src="student.avatar" class="avatar-img" alt />
        <img v-else src="@/assets/avatars/user.png" class="avatar-img" alt />
        <div class="student-info mx-2">
          <strong class="text-capitalize student-name">{{ student.firstname }} {{ student.lastname }}</strong>
          <small class="access-all-content">
            <template v-if="student.access_all_content">
              <i class="fa fa-unlock color-amber"></i>
              {{ $t('singup.accessAllContent') }}
            </template>
            <template v-else>
              <i class="fa fa-lock color-bombay"></i>
              {{ $t('singup.restrictedContent') }}
            </template>
          </small>
        </div>
      </div>
      <div class="time-activity">
        <div class="counted-minutes">
          <div class="minutes">
            <span>{{ student.all_sessions_time.sessions_time | formatDuration }}</span>
          </div>
          <div class="text-center minutes-test">
            <span>{{ $t('children.minutsOf') }} {{ $t('children.totalActivity') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="last-activity" @click="dialogVisible = true">
      <p v-if="student.last_sesson.updated_date !== '0001-01-01T00:00:00Z'">
        <span class="block">{{ $t('children.lastActivity') }}:</span>
        <template>
          <h3 class="block">{{ student.last_sesson.updated_date | relativeTimeFromNow }}</h3>
        </template>
      </p>
      <p v-else>{{ $t('children.hadNoActivity') }}</p>
    </div>

    <div
      v-focus
      class="dialog"
      :class="{ 'dialog--open': dialogVisible }"
      tabindex="0"
      @keyup.esc="dialogVisible = false"
    >
      <div ref="dialog__screen" class="dialog__screen">
        <div class="dialog__head">
          <h2 class="dialog__head-title">{{ modalTitle }}</h2>
          <button type="button" class="btn dialog__close-btn" @click="dialogVisible = false">
            <img src="@/assets/ic_close_white_24dp_1x.png" class="dialog__close-img" alt="Close" />
          </button>
        </div>
        <div class="dialog__body">
          <component
            :is="currentComponent"
            :student-id="student.id"
            :grade-id="student.grade_id"
            :student-name="student.firstname + ' ' + student.lastname"
            :student-created-at="new Date(student.registration_date)"
            @student="update"
            @cancel="handleCancel"
          />
        </div>
        <div class="dialog__actions">
          <div class="menu">
            <div class="item">
              <div :class="['item-action', { active: activeTab === 'history' }]" @click="historyHandle">
                <img class="item-img" src="@/assets/history.svg" alt />
              </div>
              <h3 class="item-text"> {{ $t('dialogActionsHistory') }}</h3>
              <!-- options start -->
              <div class="item-options">
                <div class="item">
                  <div :class="['item-action', { active: activeSubTab === 'tests' }]" @click="testsHandle">
                    <img class="item-img" src="@/assets/test.svg" alt />
                  </div>
                  <h3 class="item-text">{{ $t('dialogActionsTest') }}</h3>
                </div>
                <div class="item">
                  <div :class="['item-action', { active: activeSubTab === 'evaluations' }]" @click="evaluationsHandle">
                    <img class="item-img" src="@/assets/evaluations.svg" alt />
                  </div>
                  <h3 class="item-text">{{ $t('dialogActionsEvaluations') }}</h3>
                </div>
                <div class="item">
                  <div :class="['item-action', { active: activeSubTab === 'activity' }]" @click="activityHandle">
                    <img class="item-img" src="@/assets/activity.svg" alt />
                  </div>
                  <h3 class="item-text">{{ $t('dialogActionsActivity') }}</h3>
                </div>
              </div>
              <!-- options end -->
            </div>
            <div class="item">
              <div :class="['item-action', { active: activeTab === 'progress' }]" @click="progressHandle">
                <img class="item-img" src="@/assets/progress.svg" alt />
              </div>
              <h3 class="item-text">{{ $t('dialogActionsProgress') }}</h3>
            </div>
            <div class="item">
              <div :class="['item-action', { active: activeTab === 'attendance' }]" @click="attendanceHandle">
                <img class="item-img" src="@/assets/attendance.svg" alt />
              </div>
              <h3 class="item-text">{{ $t('dialogActionsAttendance') }}</h3>
            </div>
            <div class="item">
              <div :class="['item-action', { active: activeTab === 'edit-student' }]" @click="editStudentHandle">
                <img class="item-img" src="@/assets/edit.svg" alt />
              </div>
              <h3 class="item-text">{{ $t('dialogActionsEditStudent') }}</h3>
            </div>
            <!-- <div class="item">
              <div class="item-action" @click="deleteStudent">
                <img class="item-img" src="@/assets/delete.svg" alt />
              </div>
              <h3 class="item-text">Delete</h3>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from 'sweetalert';
import _ from 'lodash';
import TestList from './TestList.vue';
import AttendanceCalendar from './AttendanceCalendar.vue';
import StudentEdit from './StudentEdit.vue';
import EvaluationList from './EvaluationList.vue';
import ActivityList from './ActivityList.vue';
import Charts from './Chart/Index.vue';

export default {
  name: 'StudentItem',
  components: {
    TestList,
    AttendanceCalendar,
    StudentEdit,
    EvaluationList,
    ActivityList,
    Charts,
  },
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 'attendance',
      activeSubTab: '',
      currentComponent: 'AttendanceCalendar',
      dialogVisible: false,
    };
  },
  computed: {
    modalTitle: function () {
      if (this.activeTab === 'progress') return this.$t('student.progress');
      if (this.activeTab === 'attendance') return this.$t('children.attendanceCalendar');
      if (this.activeTab === 'edit-student') return this.$t('children.editStudentProfile');
      // if (this.activeTab === 'history') return this.$t('tutors.evaluations')
      if (this.activeSubTab === 'evaluations') return this.$t('tutors.evaluations');
      if (this.activeSubTab === 'activity') return this.$t('children.showActivityTimeTitle');
      if (this.activeSubTab === 'tests') return this.$t('children.showAllTestsTitle');
      return '';
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.$refs.dialog__screen.style.height =
        window.innerHeight - this.$refs.dialog__screen.getBoundingClientRect().top - 30 + 'px';
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleCancel() {
      // to home in modal
      this.activeTab = 'history';
      this.activeSubTab = 'evaluations';
      this.currentComponent = 'EvaluationList';
    },
    update(user) {
      this.$store.commit('UPDATE_FULLNAME_USER_IN_LISTOFSTUDENTS', {
        firstname: user.firstname,
        lastname: user.lastname,
        id: user.id,
      });
    },
    deleteStudent() {
      swal({
        title: this.$t('messages.areYouSure'),
        text: this.$t('messages.allStudent'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(willDelete => {
        if (willDelete) {
          this.confirmationDeleteStudent();
        }
      });
    },
    confirmationDeleteStudent() {
      var self = this;
      this.$httpMain
        .post(`delete-user`, {
          student_id: this.student.id,
        })
        .then(res => {
          if (res.data === true) {
            this.dialogVisible = false;
            swal(this.$t('messages.deleted'), this.$t('messages.yourFile'), 'success');
            // Elimina el student del array de coaches local.
            this.$store.state.sectionOfStoreOfTutor.listOfStudents = _.remove(
              this.$store.state.sectionOfStoreOfTutor.listOfStudents,
              function (student) {
                return student.id !== self.student.id;
              },
            );
          }
        });
    },
    historyHandle() {
      this.activeTab = 'history';
      this.activeSubTab = 'evaluations';
      this.currentComponent = 'EvaluationList';
    },
    progressHandle() {
      this.activeTab = 'progress';
      this.currentComponent = 'Charts';
    },
    attendanceHandle() {
      this.activeTab = 'attendance';
      this.currentComponent = 'AttendanceCalendar';
    },
    editStudentHandle() {
      this.activeTab = 'edit-student';
      this.currentComponent = 'StudentEdit';
    },
    evaluationsHandle() {
      this.activeTab = 'history';
      this.activeSubTab = 'evaluations';
      this.currentComponent = 'EvaluationList';
    },
    testsHandle() {
      this.activeTab = 'history';
      this.activeSubTab = 'tests';
      this.currentComponent = 'TestList';
    },
    activityHandle() {
      this.activeTab = 'history';
      this.activeSubTab = 'activity';
      this.currentComponent = 'ActivityList';
    },
  },
};
</script>
<style lang="sass" scoped>
$blue: #58CDE8
$purple: #C389E5
$orange: #EA990A
$magenta: #CC4F8B

$colors: $blue, $purple, $orange, $magenta

$main-color: nth($colors, random(length($colors))) !default
.student
  box-shadow: 5px 5px 10px rgba($color: #3E622D, $alpha: 0.5)
  border-radius: 8px
  background-color: rgba($color: #FFFFFF, $alpha: 1.0)
  user-select: none
  display: flex
  flex-wrap: wrap
  max-width: 900px
  margin: auto
  position: relative
  padding-right: 10px
  &:before
    right: 100%
    top: 0
    border: solid transparent
    content: " "
    height: 0
    width: 0
    position: absolute
    pointer-events: none
  &:after
    right: 100%
    top: 0
    border: solid transparent
    content: " "
    height: 0
    width: 0
    position: absolute
    pointer-events: none
  &:before
    border-color: rgba(136, 183, 213, 0)
    border-width: 10px
    top: -20px
    left: calc(50% - 15px)
    border-bottom-color: lighten($main-color, 0)
  +forDesktop
    max-width: 1200px
    justify-content: space-between
    position: relative
.student-details
  display: flex
  width: 50%
  justify-content: space-between
  flex-direction: column
  padding: 10px
  +forTablet
    flex-direction: unset
.student-info
  margin-top: .5em
  margin-bottom: .5em
  width: 100%
  display: flex
  justify-content: center
  flex-direction: column
  align-items: flex-start
  +forTablet
    justify-content: center
.student-name
  font-family: 'comfortaabold'
  font-size: 14px
  text-align: center
  +forTablet
    text-align: unset
.avatar
  margin-bottom: .5em
  display: flex
  justify-content: space-around
  width: 100%
  +forTablet
    width: 60%
  +forDesktop
    justify-content: unset
.avatar-img
  margin: auto
  display: block
  width: 50px
  height: 50px
  +forTablet
    width: 100px
    height: 100px
  +forDesktop
    margin: unset
.time-activity
  display: flex
  +forTablet
    align-items: start
.counted-minutes
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  +forTablet
    margin-right: 1em
  .minutes
    background-color: lighten($main-color, 0)
    color: #fff
    font-size: 14px
    border-radius: 5px
    padding: .2em .5em
    font-family: 'comfortaabold'
    margin-bottom: .5em
    +forTablet
      padding-top: .5em
      padding-bottom: .5em
      width: 100px
      font-size: 18px
      margin-bottom: .2em
  .minutes-test
    font-size: 12px
    +forTablet
      font-size: 16px
      width: 100px
.last-activity
  position: relative
  padding: 20px 5px
  color: #fff
  font-family: 'comfortaabold'
  margin: -10px 0 -10px 0
  box-shadow: 5px 5px 10px rgba(62, 98, 45, 0.5)
  line-height: 1.4
  background-color: lighten($main-color, 8%)
  border-top-right-radius: 5px
  border-bottom-right-radius: 5px
  border-bottom-left-radius: 5px
  font-size: 14px
  width: 50%
.menu
  height: auto
  width: 100%
  display: flex
  justify-content: center
  .item
    margin-left: .5em
    margin-right: .5em
    position: relative
  .item-action
    background-color: #549CF2
    border-radius: .5rem
    width: 40px
    height: 40px
    display: flex
    justify-content: center
    align-items: center
    transition: 0.3s
    margin: 0 auto .5em auto
    &:hover
      background-color: #EDBE2A
      &~.item-options
        display: flex
      .item-img
        width: 20px
        height: 20px
    &.active
      background-color: #EDBE2A
    +forDesktop
      width: 60px
      height: 60px
  .item-img
    width: 20px
    height: 20px
    transition: 0.3s
    +forDesktop
      width: 35px
      height: 35px
  .item-text
    font-family: 'comfortaabold'
    text-align: center
    font-size: 10px
    +forDesktop
      font-size: 14px
  .item-options
    display: none
    background-color: #76AFC3
    position: absolute
    top: -5em
    left: 0px
    width: 200px
    justify-content: space-between
    padding: .5em
    transition: 0.3s
    border-radius: 1em
    border-bottom: 4px solid #fff
    z-index: 999
    &:hover
      display: flex
    .item
      margin-left: unset
      margin-right: unset
    .item-action
      width: 40px
      height: 40px
      background-color: #fff
      +forDesktop
        width: 50px
        height: 50px
      &:hover
        .item-img
          width: 25px
          height: 25px
      &.active
        border: 2px solid #20c997
    .item-img
      width: 25px
      height: 25px
      transition: 0.3s
    .item-text
      color: #fff
    +forDesktop
      top: -6em
      width: 300px
      padding: .5em .8em
.block
  display: block
.color-bombay
  color: #b2b5b7
.color-amber
  color: #ffc107
.access-all-content
  margin-top: .5em
  font-size: 12px
  text-align: center

.dialog
  position: fixed
  top: 0
  right: 0
  left: 0
  bottom: 0
  display: none
  z-index: 999
  background-color: rgba(64, 157, 164, 0.6)
  padding: 1em .5em
  +modifier('open')
    display: block
  +element('screen')
    background-color: #fff
    border-radius: 5px
    position: relative
  +element('head')
    padding: .5em
    height: 40px
  +element('body')
    height: calc(100% - 120px)
    overflow: auto
    display: flex
    position: relative
    +forDesktop
      height: calc(100% - 160px)
      justify-content: center;
      align-items: center;
  +element('actions')
    padding: 1em 0
    height: 80px
    +forDesktop
      height: 120px
  +element('close-btn')
    position: absolute
    top: 5px
    right: 5px
    background-color: #ff1800
    border-radius: 50%
    padding: 3px
    display: flex
    align-items: center
    justify-content: center
  +element('close-img')
    width: 15px
</style>
